require('../styles/modules/redo.scss');
import React, { Component, PropTypes } from 'react'

class Redo extends Component {
  render() {
    return (
      <div className = 'redo-button'>
        <i className="redo fa fa-refresh" aria-hidden="true"></i>
      </div>
    )
  }
}
export default Redo



// WEBPACK FOOTER //
// ./components/Redo.js